// Brand colors
export const MOOD_BRAND = {
  teal: '#1A5F7A',
  gold: '#D4AC0D',
  burgundy: '#7D1935',
  darkTeal: '#0d3d50',
  cream: '#f5f0e8',
} as const;

// Mood pill color
export const MOOD_PILL_COLOR = { bg: '#7D1935', color: '#fff' };

// Max active moods in the app grid
// V5.5 2026-08-09: raised 4 → 5 for the Neutral mood (product-default no-op
// overlay, migration 439). Keep in sync with MAX_ACTIVE_MOODS in
// backend/routes/admin/aiMoodsAdmin.js.
export const MAX_ACTIVE_MOODS = 5;
